// @flow
import { PRODUCT_TAGS } from 'Client/cms/toolkit/constants';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { LINE_COMMON_PRODUCT_TAGS } from 'Utils/request/requestDictionary';
import resortThumbnailQuery, {
  type ThumbnailProduct,
} from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import * as configQueries from 'Views/configQueries';

export type CMSProps = {|
  id: string,
  seeAllProductsLink: CMSLink,
  tags: Array<{
    label: string,
    productIds: Array<string>,
  }>,
  title: string,
|};

export type GQLProps = {|
  config: {
    common: {
      close: string,
      scrollBackward: string,
      scrollForward: string,
    },
    price: { format: { from: string } },
  },
  products: $ReadOnlyArray<ThumbnailProduct>,
|};

export const productTagsResolver = {
  name: PRODUCT_TAGS,
  resolve: async (appContext: AppContext, props: CMSProps): Promise<GQLProps> => {
    const allProductIds = props.tags.reduce((acc, tag) => [...acc, ...tag.productIds], []);
    const productIdsAsString = JSON.stringify(allProductIds);

    const { cmsContent = '', cmsRelease = '' } = appContext;

    const resortThumbnailQueryString = resortThumbnailQuery({
      content: cmsContent,
      release: cmsRelease,
    });

    const query = `query {
      config {
        common {
          close
          scrollBackward
          scrollForward
        }
        ${configQueries.price()}
        ${configQueries.resort(appContext)}
      }
      products: resorts(resortIds: ${productIdsAsString}) {
        ${resortThumbnailQueryString}
      }
    }`;

    return graphQLClient.runQuery(query, appContext, {
      requestName: LINE_COMMON_PRODUCT_TAGS,
    });
  },
};
